const theme = {
  mobile: "(max-width: 770px)",
};

export default theme;
